// @core/api/endpoints/tenant/test_tenant_sso_config.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  TestTenantSSOConfigRequest,
  TestTenantSSOConfigResponse,
} from '../../../types/tenant';

const BASE_PATH = '/tenant';

/**
 * Test SSO configuration
 * Performs a validation test of the SSO configuration, checking connectivity, certificate validity, and endpoint availability without affecting live settings.
 */
export async function TestTenantSSOConfig(
  tenant_id: string,
  data: TestTenantSSOConfigRequest,
  options?: RequestOptions
): Promise<TestTenantSSOConfigResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/:tenant_id/sso/test`;
  requestPath = requestPath.replace(':tenant_id', encodeURIComponent(tenant_id));
  const requestOptions = options;
  return client.post<TestTenantSSOConfigResponse>(requestPath, data, requestOptions);
}
